var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonorSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91699 5.07215L10.5448 10.9325L15.3699 5.85567C14.4833 2.69764 12.1952 -0.14128 6.01356 0.00546485C5.57624 0.0158603 0.052063 0.00546485 0.052063 0.00546485L4.91699 5.07215Z",
    fill: "#E67C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95348 16.8152L4.91718 5.07196L0.051822 0.00479126L0 21.9993H4.96944L4.95348 16.8152Z",
    fill: "#102835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9859 11.1936C15.9282 9.66136 15.8888 7.70412 15.3699 5.85591L10.5446 10.9327L4.95349 16.8161L4.96945 22.0002H7.91325C15.1086 21.3117 16.1416 15.3242 15.9859 11.1936Z",
    fill: "#48B8BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorSearch);
export default __webpack_public_path__ + "static/media/donor-search.c15df1ae5fe946540e528910095fa167.svg";
export { ForwardRef as ReactComponent };